import { useEffect, useState } from 'react';
import './Minor_scales.css';

import logo from './images/logo.png';

import tick from './images/tick.png';
import bg_img from './images/minor.webp';
import up_icon1 from './images/up_icon.png';
import up_icon2 from './images/down_icon.png';

import '../Components/assets/style.css';
import Piano from './Piano';
//react navigation
import { Link } from "react-router-dom";

import tune from '../Components/assets/tunes/correct-answer.mp3';

import './CustomAlert.css'

const Minor_scales = () => {


    const [currentNoteIndices, setCurrentNoteIndices] = useState(Array(8).fill(0));
    const notes = ['A', 'A#', 'Bb', 'B', 'C', 'C#', 'Db', 'D', 'D#', 'Eb', 'E', 'F', 'F#', 'Gb', 'G', 'G#', 'Ab'];
    const [answer, setAnswer] = useState(Array(8).fill('A')); // Initialize answer array with A alphabet


    const [showAlert, setShowAlert] = useState(false);

    const [right_answer, setRightAnswer] = useState([]);

    const [showVideo, setShowVideo] = useState(false);


    const handleNoteChange = (step, boxIndex) => {
        setCurrentNoteIndices(prevIndices => {
            const newIndices = [...prevIndices];
            newIndices[boxIndex] = (newIndices[boxIndex] + step + notes.length) % notes.length;
            const noteText = notes[newIndices[boxIndex]];

            // Update the answer array with the note text at the corresponding index
            setAnswer(prevAnswer => {
                const newAnswer = [...prevAnswer];
                newAnswer[boxIndex] = noteText;
                return newAnswer;
            });
            return newIndices;
        });
    };

    const minor_scales_keys = ['A', 'E', 'B', 'F#', 'C#', 'G#', 'D', 'C', 'G', 'F', 'Bb']
    const u_tube_video = {
         1: ['https://www.youtube.com/embed/Q8usHCOEGMU'],
        2: ['https://www.youtube.com/embed/-XYyvV96LKk'],
        3: ['https://www.youtube.com/embed/sFaioLXicB4'],
        4: ['https://www.youtube.com/embed/CvWVEz9SJ_w'],
        5: ['https://www.youtube.com/embed/qx_Q5J5QSCQ'],
        6: ['https://www.youtube.com/embed/Cl4nwn2Aivk'],
        7: ['https://www.youtube.com/embed/Pc32yE1BRdU'],
        8: ['https://www.youtube.com/embed/khwhrhIbyCQ'],
        9: ['https://www.youtube.com/embed/T61THfl8Rjc'],
        10: ['https://www.youtube.com/embed/coOaq1gqMiA'],
        11: ['https://www.youtube.com/embed/hujAqgYf33c']
    };
    let selectedVideo = '';



    function video_selection() {
        const matchIndex = minor_scales_keys.findIndex(item => item === right_answer[0]);

        if (matchIndex !== -1) {
            selectedVideo = u_tube_video[matchIndex + 1] || '';
        } else {

            console.log('No matching item found');
        }
    }


    useEffect(() => {

        for (const boxIndex in correct_answer) {
            const correctAnswer = correct_answer[boxIndex];

            if (arraysAreEqual(answer, correctAnswer)) {

                const audio = new Audio(tune);
                audio.play();

                setRightAnswer([...correctAnswer])

                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                }, 5000);

                setShowVideo(true);

                break;

            } else {
                setShowVideo(false);
                setRightAnswer(null);
            }
        }
    }, [answer]);

    const arraysAreEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) {
            return false;
        }

        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }

        return true;
    };


    const correct_answer = {
        1: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'A',],
        2: ['E', 'F#', 'G', 'A', 'B', 'C', 'D', 'E'],
        3: ['B', 'C#', 'D', 'E', 'F#', 'G', 'A', 'B',],
        4: ['F#', 'G#', 'A', 'B', 'C#', 'D', 'E', 'F#'],
        5: ['C#', 'D#', 'E', 'F#', 'G#', 'A', 'B', 'C#'],
        6: ['G#', 'A#', 'B', 'C#', 'D#', 'E', 'F#', 'G#'],
        7: ['D', 'E', 'F', 'G', 'A', 'Bb', 'C', 'D'],
        8: ['G', 'A', 'Bb', 'C', 'D', 'Eb', 'F', 'G'],
        9: ['C', 'D', 'Eb', 'F', 'G', 'Ab', 'Bb', 'C'],
        10: ['F', 'G', 'Ab', 'Bb', 'C', 'Db', 'Eb', 'F',],
        11: ['Bb', 'C', 'Db', 'Eb', 'F', 'Gb', 'Ab', 'Bb',],
    }

    return (

        <div className="homePage-bg_minor_scales">

            {/* navbar code */}
            <div className="mainContainer_navbar_minor_scales" >
                <div className='cont0_navbar_minor_scales'>
                    <div className='cont1_navbar'>
                        <img src={logo} className='logo' />
                        <a href='#' className='nav_bar_txt'>Musical Scales Games</a>
                    </div>

                    <div className='cont2_navbar'>
                        <a href="#" className='nav_btns_minor_scales' >
                            <Link to="/" style={{ color: 'white', textDecoration: 'none' }} >
                                Major Scales
                            </Link>
                        </a>
                        <a href="#" className='nav_btns_minor_scales' >
                            <Link to="/major-pentatonic" style={{ color: 'white', textDecoration: 'none' }}>
                                Major Pentatonic
                            </Link>
                        </a>
                        <a href="#" className='nav_btns_minor_scales' >
                            <Link to="/major-blues" style={{ color: 'white', textDecoration: 'none' }}>
                                Major Blues
                            </Link>
                        </a>
                    </div>
                    <div className='cont3_navbar'>
                        <a href="#" className='nav_btns_minor_scales' >
                            <Link to="/minor-scales" style={{ color: 'white', textDecoration: 'none' }}>
                                Minor Scales
                            </Link>
                        </a>
                        <a href="#" className='nav_btns_minor_scales' >
                            <Link to="/minor-pentatonic" style={{ color: 'white', textDecoration: 'none' }}>
                                Minor Pentatonic
                            </Link>
                        </a>
                        <a href="#" className='nav_btns_minor_scales' >
                            <Link to="/minor-blues" style={{ color: 'white', textDecoration: 'none' }}>
                                Minor Blues
                            </Link>
                        </a>
                    </div>
                    
                </div>
            </div>
            {/* navbar code */}


            <div className='s1_cont_minor_scales'>
                <h3 className='heading' >Minor Scales</h3>
                <div className='cont0'>
                    <img src={bg_img} className='bg-img' />
                </div>

                <div className='homeBtns'>
                    <h3 className='heading_majorscales' >
                        Use Arrows to change Notes
                    </h3>
                    <div class="text-container0">

                        {currentNoteIndices.map((currentNoteIndex, boxIndex) => (
                            <div className="text-container1" key={boxIndex}>
                                <a href="#" className="up_arrow_btn" onClick={(e) => { e.preventDefault(); handleNoteChange(1, boxIndex); }}>
                                    <img src={up_icon1} className="arrow_img" alt="Up Arrow" />
                                </a>
                                <p className="txt_cont">{notes[currentNoteIndex]}</p>
                                <a href="#" className="up_arrow_btn" onClick={(e) => { e.preventDefault(); handleNoteChange(-1, boxIndex); }}>
                                    <img src={up_icon2} className="arrow_img" alt="Down Arrow" />
                                </a>
                            </div>
                        ))}

                        {showAlert && (
                            <div className="custom-alert">
                                <img src={tick} className='tick-icon' />
                                <p className="alert-text">Correct Answer</p>
                            </div>
                        )}

                    </div>

                    <div>
                        <h3 className='heading' >
                            Piano
                        </h3>
                        <div>
                            <Piano correctAnswer={right_answer} />
                        </div>
                    </div>




                    {showVideo ? (
                        <div>
                            <h3 style={{ textAlign: 'center', marginTop: '10px', fontSize: '20px', color: 'white' }} >Correct Keys</h3>
                            <div className='correct-words' >
                                {right_answer.map((word, index) => (
                                    <div key={index} className="word">{word}</div>
                                ))}
                                {video_selection()}

                            </div>

                            <div>
                                <h3 style={{ textAlign: 'center', marginTop: '10px', fontSize: '25px', color: 'white' }}>Related Video</h3>
                                <div className='video'>
                                    <iframe
                                        title="My Video"
                                        width="800"
                                        height="160"
                                        style={{ borderRadius: '10px' }}
                                        src={selectedVideo}
                                        frameBorder="0"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        </div>) : null
                    }
                </div>
            </div>

        </div>

    );
};

export default Minor_scales;